import React, { useEffect } from "react";
import css from "./WebDevelopment.module.scss";
import SecOne from "./SecOne/SecOne";
import SecTwo from "./SecTwo/SecTwo";
import SecThree from "./SecThree/SecThree";
import SecFour from "./SecFour/SecFour";
import { constants } from "assets/constants";
import { Helmet } from "react-helmet";

const WebDevelopment = () => {
    return (
        <div className={css.web}>
            <Helmet>
                <title>{constants.titles.services_web}</title>
                <meta name="description" content={constants.descriptions.services_web} />
            </Helmet>
            <SecOne />
            <SecTwo />
            <SecThree />
            <SecFour />
        </div>
    );
};

export default WebDevelopment;
